export const BuyInfoTag = ({
  children,
}) => {
  return (
    <div className="p-[2px_10px] text-[12px] sm:text-[10px] text-[#fff] border-solid border-[1px] border-[#fff] rounded-[5px] absolute right-[10px] top-[10px] z-10">
      <span className="leading-normal">{children}</span>
    </div>
  );
};